"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var statementApi = _interopRequireWildcard(require("@/api/merchantStatement"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RejectStatementDialog',
  data: function data() {
    return {
      visible: false,
      submitLoading: false,
      form: {
        id: '',
        rejectReason: ''
      },
      rules: {
        rejectReason: [{
          required: true,
          message: '请输入驳回原因',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    open: function open(row) {
      this.form = {
        id: row.id,
        rejectReason: ''
      };
      this.visible = true;
    },
    handleClosed: function handleClosed() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
      this.submitLoading = false;
    },
    handleSubmit: function handleSubmit() {
      var _this = this;
      this.$refs.formRef.validate(function (valid) {
        if (!valid) return;
        _this.submitLoading = true;
        statementApi.statementRejectApi({
          id: _this.form.id,
          rejectReason: _this.form.rejectReason
        }).then(function () {
          _this.$message.success('驳回成功');
          _this.visible = false;
          _this.$emit('refresh');
        }).catch(function () {}).finally(function () {
          _this.submitLoading = false;
        });
      });
    }
  }
};